import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {SiteFilter} from '../../models/site-filter';
import {ContextualMenuContainerComponent} from '../../../shared/components/contextual-menu-container/contextual-menu-container.component';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../../../site/reducers';
import {ActivatedRoute, convertToParamMap, Params} from '@angular/router';
import * as fromRoot from '../../../shared/reducers';
import {distinctUntilChanged, filter, map, tap, withLatestFrom} from 'rxjs/operators';
import * as _ from 'lodash';
import {Office, replace, Role} from '../../../shared';
import {SelectedItem} from '../../../order/models/order';
import {SetPreferencesAction} from '../../../shared/actions/preferences';
import {SiteItem} from '../../models/site-item';
import {SitesFilterComponent} from '../../components/sites-filter/sites-filter.component';
import {
  ChangeSitesPageSizeAction,
  ClearSelectedSitesAction,
  ClearSitesAction, ExportExcelAllSitesAction,
  LoadSitesAction,
  OrderSitesByAction,
  PageSitesToAction,
  QuickSearchSitesAction,
  SearchSitesAction, SelectSitesPageAction,
  ToggleSearchSitesAction,
  ToggleSitesSelectionAction
} from '../../actions/site-list';
import {Site} from '../../../shared/models/site';
import {SubscriptionI} from '../../../shared/models/subscription-i';
import {MenuItem} from '../../../shared/models/context-menu-data';
import {Address} from '../../../shared/models/address';
import {MergeClientDialogComponent} from '../../components/merge-client-dialog/merge-client-dialog.component';
import {MergeSiteAction} from '../../actions/merge-site-of-client';
import {ModalComponent} from '@storever/modal-confirmation';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {L10N_LOCALE, L10nLocale, L10nTranslationService} from 'angular-l10n';
import {ModalBulkStatusOffToOffComponent} from '../../components/modal-bulk-status-off-to-off/modal-bulk-status-off-to-off.component';
import {BulkUpdateStatusAction} from '../../actions/update-status';

@Component({
  selector: 'storever-sites-list',
  templateUrl: './sites-list.component.html',
  styleUrls: ['./sites-list.component.scss']
})
export class SitesListComponent implements OnInit, OnDestroy {

  checkAll: boolean;
  count$: Observable<number>;
  filter$: Observable<SiteFilter>;
  orderBy$: Observable<string>;
  office$: Observable<Office[]>;
  allowOrderCreation = true;
  sites$: Observable<Site[]>;
  sites: Site[];
  page$: Observable<number>;
  pageSize$: Observable<number>;
  quickSearch$: Observable<string>;
  selectedItemUuid$: Observable<string>;
  showFilter$: Observable<boolean>;
  roles$: Observable<Role[]>;
  menuTitle: string;
  selectedItem$: Observable<SelectedItem[]>;
  // tslint:disable-next-line:no-any
  menuItem: any;
  bsModalRef: BsModalRef;
  mainMenuItem = this.createMenuContextualListAction();
  // tslint:disable-next-line:no-any
  breadcrumbData: any;
  @ViewChild('filter', {static: false}) filter: SitesFilterComponent;
  @ViewChild('contextualMenuContainer', {static: false}) contextualMenuContainer: ContextualMenuContainerComponent;
  @ViewChild('mergeClientModal' , {static: true}) mergeClientModal: MergeClientDialogComponent;
  @ViewChild('bulkUpdateModal' , {static: true}) bulkUpdateModal: ModalBulkStatusOffToOffComponent;
  checkBockStatus: boolean;
  private sub$: Subscription;
  private subscriptions = [];
  storeCurrentClient: string;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private store: Store<fromSites.AppState>,
              private activatedRoute: ActivatedRoute,
              private translation: L10nTranslationService,
              private storeRoot: Store<fromRoot.AppState>,
              private modalService: BsModalService) {
    const query$ = this.store.pipe(
      select(fromRoot.selectors.getRouterState),
      filter(state => !_.isEmpty(state)),
      map(state => state.queryParams),
      tap((params: Params) => {
        this.checkAll = false;
        this.checkBockStatus = false;
      })
    );
    this.storeSelect();

    this.filter$ = query$.pipe(map(query => Object.assign(query)));
    this.orderBy$ = query$.pipe(map(convertToParamMap), map(query => query.get('$orderBy')));
    this.quickSearch$ = query$.pipe(map(convertToParamMap), map(query => query.get('quickSearch')));
    this.page$ = query$.pipe(map(convertToParamMap), map(query => parseInt(query.get('$page') || '1', 10)));
    this.roles$ = this.store.pipe(select(fromRoot.selectors.getMyRoles));
    let pageSizeInit = true ;
    this.sub$ = this.pageSize$.subscribe(pageSize => {
      if ( pageSizeInit && pageSize) {
      this.store.dispatch(new ChangeSitesPageSizeAction(pageSize));
      pageSizeInit = false;
      }
    });
    this.subscriptions.push(this.sub$);

    this.office$ = this.storeRoot.pipe(select(fromRoot.selectors.getOffices));
    this.storeRoot.pipe(select(fromRoot.selectors.getCurrentClient)).subscribe(data => {
      if (data) {
        this.office$.subscribe(dataO => {
          if (dataO) {
            for (let i = 0; i < dataO.length; ++i) {
              if (data.office === dataO[i].id) {
                this.allowOrderCreation = dataO[i].allowOrderCreation
              }
            }
          }
        })
      }

    })
  }

  ngOnInit(): void {
    let loadDataOnChangeUrl = true;
    window.scroll(0, 0);
    this.sub$ = this.activatedRoute.queryParams.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y)),
      withLatestFrom(this.store.pipe(select(fromRoot.selectors.getPreferencesByName, 'sites_row_size')))
    ).subscribe(([query, length]) => {
          if (!query.$page) {
            this.store.dispatch(replace([] , {$page: 1, $length: length, $orderBy: 'displayName'} ))
          } else if (loadDataOnChangeUrl) {
            this.store.dispatch(replace([] , Object.assign( {} , query ,
              {$page: 1, $length: length, $orderBy: 'displayName' }  )))
            loadDataOnChangeUrl = false;
          }
          this.store.dispatch(new LoadSitesAction());
          this.checkAll = false;

      });
    this.subscriptions.push(this.sub$);
  }

  ngOnDestroy(): void {
  //  this.storeRoot.dispatch(new HeaderTitleClearAction());
    this.store.dispatch(new ClearSitesAction());
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }


  storeSelect(): void {

    this.pageSize$ = this.store.pipe(select(fromRoot.selectors.getPreferencesByName, 'sites_row_size'));
    this.count$ = this.store.pipe(select(fromSites.selectors.getSitesCount));
    this.showFilter$ = this.store.pipe(select(fromSites.selectors.getSiteShowFilter));
    this.sites$ = this.store.pipe(select(fromSites.selectors.getSites));
    this.sub$ = this.sites$.subscribe(sites => {
      this.sites = sites;
    });
    this.subscriptions.push(this.sub$);

    this.selectedItemUuid$ = this.store.pipe(select(fromRoot.selectors.getSelectedItemUuid));
    this.selectedItem$ = this.store.pipe(select(fromSites.selectors.getSiteSelectedSites));
    let pageSizeInit = true ;
    this.sub$ = this.pageSize$.subscribe(pageSize => {
      if ( pageSizeInit ) {
        this.store.dispatch(new ChangeSitesPageSizeAction(pageSize));
        pageSizeInit = false;
      }
    });
    this.subscriptions.push(this.sub$);

    // this.sub$ = this.store.pipe(
    //   select(fromRoot.selectors.getCurrentClient),
    //   filter(client => client != undefined)
    // ).subscribe(( client => {
    //   if (client) {
    //     this.storeCurrentClient = client.uuid;
    //     this.breadcrumbData = this.getBreadConfigSiteService.getBreadConfigSiteList().data;
    //     this.storeRoot.dispatch(new HeaderTitleAction({icon: 'fal fa-user' , title: client.name}));
    //   }
    // }));
    // this.subscriptions.push(this.sub$);
    this.sub$ = this.selectedItem$.subscribe((sitesSelected: SelectedItem[]) => {
      this.checkDataLength(sitesSelected);
      if (sitesSelected && sitesSelected.length) {
      //  this.store.dispatch(new LoadSitesSelectedAction(orders));
      }
    });
    this.subscriptions.push(this.sub$);
  }

  pageChanged(page: number): void {
    this.store.dispatch(new PageSitesToAction(page));
  }

  pageSizeChanged(pageSize: number): void {
    this.store.dispatch(new SetPreferencesAction({ name: 'sites_row_size', value: '' + pageSize }));
    this.store.dispatch(new ChangeSitesPageSizeAction(pageSize));
  }

  orderByChanged(orderBy: string): void {
    this.store.dispatch(new OrderSitesByAction(orderBy));
  }

  selectAll(e: boolean): void {
    this.checkAll = e;
    this.store.dispatch(new ClearSelectedSitesAction());
    if (e) {
      this.checkBockStatus = true;
      this.store.dispatch(new SelectSitesPageAction())
    }
  }

  applyFilter(filterForm: SiteFilter): void {
    if (filterForm) {
      filterForm.country = filterForm.country ? filterForm.country['code'] : null;
      filterForm.status = filterForm.status ? filterForm.status['id'] : null;
    }
    this.store.dispatch(new SearchSitesAction(filterForm));
    this.checkAll = false;
  }

  applyQuickFilter(query: string): void {
    this.store.dispatch(new QuickSearchSitesAction(query));
    this.checkAll = false;
  }

  toggleFilter(showFilter: boolean): void {
    this.store.dispatch(new ToggleSearchSitesAction(showFilter));
  }

  hideDatatableMenu(value: boolean): void {
    if (value) {
      this.menuTitle = '';
    } else {
      this.menuTitle = 'actions';
    }
  }

  checkDataLength(value: SelectedItem[]): void {
    if (value.length > 0) {
      this.hideDatatableMenu(false);
    } else {
      this.hideDatatableMenu(true);
    }
  }
  // tslint:disable-next-line:no-any
  createMenuContextual(row?: any, status?: string, product?: string): MenuItem[] {
    this.menuItem = [];
    if (this.menuItem.length === 0) {
      if (row.subscriptionCount === 1 && this.allowOrderCreation) {
        this.menuItem.push(
          new MenuItem('fal fa-exchange',
            'ORDERS_EXCHANGE_TITLE',
            'ORDERS_EXCHANGE_TITLE',
            'link',
            ['/', 'orders', 'add' , row.uuid],
            row.uuid ? row.uuid : null)
        );
      }

      this.menuItem.push(
        new MenuItem(
          'fal fa-times-circle',
          'SUBSCRIPTION_BULK_STATUS_UPDATE',
          'SUBSCRIPTION_BULK_STATUS_UPDATE',
          'modal',
          this.bulkUpdateModal,
          null)
      );
    }
    return this.menuItem;
  }

  toggleSelected(site: SiteItem): void {
    // this.store.dispatch(new ClearSelectItemAction());
    this.store.dispatch(new ToggleSitesSelectionAction({ uuid: site.uuid , name: site.name }));
  }

  getNamesSub(subs: SubscriptionI[]): string {
    let names = '';
    subs.forEach(sub => names += `<div>` + sub.name + `</div>`);
    return names;
  }

  getAddressesAtIndexByType(row: Address[], index: number, type: string): void {
    return row['addresses'][index][type]
  }


  createMenuContextualListAction():  MenuItem[]  {
    // we wait for initialisation of a modal
    const promise = Promise.resolve(this.mergeClientModal);
    promise.then((val) => this.initMenuItem());
    return  this.mainMenuItem;
  }

  initMenuItem():  MenuItem[] {
    this.mainMenuItem = [];
    if ( this.mergeClientModal ) {
      this.mainMenuItem.push(
        new MenuItem(
          'fal fa-object-group',
          'SITE_LIST_MERGE_SITE_CLIENT',
          'SITE_LIST_MERGE_SITE_CLIENT',
          'modal',
          this.mergeClientModal,
          null)
      );
    }

    return  this.mainMenuItem;
  }
  // tslint:disable-next-line:no-any
  mergeSiteOfClient(data: any): void {
    const initialState = {
      title: 'CONFIRMATION',
      message: 'You will move {{countSites}} sites to the client {{clientName}} and you need to publish new content on your player, you have 10 minutes before your screen become black.',
      variable: null,
      deleteBtn: false,
      hideBtnOk: true
    };
    this.bsModalRef = this.modalService.show(ModalComponent, {initialState});
    this.bsModalRef.content.message = this.translation.translate('SITE_LIST_MERGE_CLIENT_MESSAGE',
      {countSites: data.sitesUuid.length, clientName: data.clientNameDestination});
    this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
      if (this.bsModalRef.content.isConfirmed) {
        this.store.dispatch(new MergeSiteAction(data));
        this.checkAll = false;
      }

    });
    this.subscriptions.push(this.sub$);
  }
  exportAsXLSX(): void {
    // this.excelService.exportAsExcelFile(this.sites, 'sites_data');
    this.store.dispatch(new ExportExcelAllSitesAction());
  }
  // tslint:disable-next-line:no-any
  bulkUpdateStatus(data: any): void {
    this.store.dispatch(new BulkUpdateStatusAction(data));
  }

  isInRole$(role: string): Observable<boolean> { return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1)); }
}
